import mixpanel from 'mixpanel-browser';

import { getBrowserInfoForMixpanel } from '../../../../shared-utility/src/index';

const mixPanelConfig = {
  shouldUseMixPanel: false,
  isInitialized: false,
};

export const identifyUser = (identifyId, registerOptions = {}) => {
  if (!mixPanelConfig.isInitialized) {
    return;
  }

  mixpanel.identify(identifyId);
  mixpanel.register(registerOptions);
};

export const initMixPanel = ({ enableBrowserInfoTracking = true } = {}) => {
  mixPanelConfig.isInitialized = false;

  const MIXPANEL_PROJECT_TOKEN = process.env.NX_PUBLIC_MIXPANEL_PROJECT_TOKEN;

  if (MIXPANEL_PROJECT_TOKEN) {
    try {
      const mixpanelSettings = {
        persistence: 'localStorage',
        record_sessions_percent: 1, // Enable Session Replay for 1% of sessions
        record_heatmap_data: true, // Enable Heatmap data collection

        // Session Replay: unmask everything for analysis (text, inputs, images, video, canvas).
        // Sensitive inputs (password, email, tel, hidden) are always masked by the SDK.
        record_mask_all_text: false,
        record_mask_all_inputs: false,
        record_block_selector: '', // Block nothing — img, video, audio are recorded
        record_canvas: true, // Record canvas (camera/selfie/document)
      };

      mixpanel.init(MIXPANEL_PROJECT_TOKEN, mixpanelSettings);

      // Registra informações do browser como super properties
      // Essas propriedades serão enviadas automaticamente em todos os eventos
      if (enableBrowserInfoTracking) {
        const browserInfo = getBrowserInfoForMixpanel();
        mixpanel.register(browserInfo);
      }

      mixPanelConfig.isInitialized = true;
    } catch (error) {
      console.error('[MixPanel][initMixPanel]', error);
      mixPanelConfig.isInitialized = false;
    }
  }
  return mixPanelConfig.isInitialized;
};

export const pushToMixPanel = (dataLayer) => {
  if (!mixPanelConfig.isInitialized) {
    return;
  }

  mixpanel.track(dataLayer.event, {
    ...dataLayer,
  });
};
